import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var CreditCardIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M19 4a4 4 0 014 4v8a4 4 0 01-4 4H5a4 4 0 01-4-4V8a4 4 0 014-4h14zm2 6H3v6a2 2 0 002 2h14a2 2 0 002-2v-6zm-11 4a1 1 0 01.117 1.993L10 16H5a1 1 0 01-.117-1.993L5 14h5zm3 0h1a1 1 0 01.117 1.993L14 16h-1a1 1 0 01-.117-1.993L13 14h1zm6-8H5a2 2 0 00-2 2h18a2 2 0 00-2-2z",
                        fillRule: "nonzero"
                    })
                })
            })
        ]
    });
};
CreditCardIcon.isCarinaIcon = true;
export default CreditCardIcon;
